import { MarketCountryCode } from '@backmarket/http-api'

// These values are used by our tracking 3rd party tools.
// Do not update them.
export type Cookie =
  | 'functional'
  | 'advertising'
  | 'analytics'
  | 'userExperience'

export type CustomizableCookie = Exclude<Cookie, 'functional'>

// These values are set in user's cookie storage and used by other stacks.
// Do not update them.
export const COOKIES: Record<CustomizableCookie, string> = {
  advertising: 'BM_Advertising',
  analytics: 'BM_Analytics',
  userExperience: 'BM_User_Experience',
}

export const COUNTRIES_WITHOUT_MODAL = [
  MarketCountryCode.AU,
  MarketCountryCode.US,
]

export const COOKIES_TRACKING_PREFIX = 'CMP'

export const COOKIES_TRACKING_NAME = {
  ACCEPT: 'accept',
  BANNER: 'v1',
  BACK: 'back',
  DATA_PROTECTION: 'data_protection',
  INFO: 'more_information',
  LEGAL_MENTIONS: 'legal_mentions',
  MODAL: 'v2',
  MODAL_STEP: 'step',
  REFUSE: 'refuse',
  SAVE: 'save_settings',
  SETTINGS: 'settings',
  TOGGLE: 'toggle',
}

export const LEGAL_PAGE_NAME = {
  DATA_PROTECTION: 'data-protection',
  OTHER: 'other-information',
  BUYBACK: 'terms-of-trade-in',
  COOKIES: 'cookies',
  TERMS_SALE: 'terms-of-sale',
  TERMS_USE: 'terms-of-use',
  TERMS_SERVICE: 'terms-of-service',
  WARRANTY: 'warranty',
  LEGAL_MENTIONS: 'legal-mentions',
}
